import { useState } from "react";
import { useAppStore } from "@/store/appStore";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import Image from "@/components/image";
import Text from "@/components/text/text";
import { useModelViewerStore } from "@/store/modelViewerStore";

const SightlineVerifierLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="fullscreen_div">
      {children}
    </div>
  );
};

export default SightlineVerifierLayout;
